// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import postResultEntity from './entities/post-result.json';
import postResultMenu from '../pages/post-result/menu.json';
import postResultFullForm from '../pages/post-result/forms/full.json';
import postResultContextForm from '../pages/post-result/forms/context.json';
import postResultMiniForm from '../pages/post-result/forms/mini.json';
import postResultLookupForm from '../pages/post-result/forms/lookup.json';
import postResultTableView from '../pages/post-result/views/table.json';
import postResultCardsView from '../pages/post-result/views/cards.json';
import postResultDashboardView from '../pages/post-result/views/dashboard.json';

/** Тип запису «Результат допису» зі сторінками пакета: меню, форми та подання з pages/post-result/. */
export const postResultDefinition: IRecordTypeDefinition = {
  ...postResultEntity,
  views: assembleViewSet({
      table: postResultTableView,
      cards: postResultCardsView,
      dashboard: postResultDashboardView,
  }),
  form: postResultFullForm,
  forms: { full: postResultFullForm, context: postResultContextForm, mini: postResultMiniForm, lookup: postResultLookupForm },
  menu: postResultMenu,
} as IRecordTypeDefinition;
